// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2PGjh","inner":"Form_inner__PfuVj","range":"Form_range__2zuTY","name":"Form_name__1_gXW","actions":"Form_actions__Fc19f"};